<template lang="pug">
  .b-spec-popover(:class="{ right: align === 'right' }")
    slot
</template>

<script>
/**
 * Всплывающая панель меню (ТЗ 6.2): меню экспорта, меню действий строки, меню ячейки фото,
 * список источников плановой цены, меню экспорта ведомости. Раньше этот блок был скопирован в
 * пяти местах — теперь он один, а содержимое каждый раз своё.
 *
 * Пункты меню оформляются классом-хуком `spec-popover-item` на элементе пункта (кнопка, ссылка
 * или подпись поля выбора файла); видимостью и закрытием управляет владелец панели.
 * Сгенерировано Claude.
 */
export default {
  name: 'SpecPopover',
  props: {
    /** С какого края панель прижата к открывшей её кнопке. */
    align: { type: String, default: 'left' },
  },
};
</script>

<style scoped lang="scss">
.spec-popover {
  position: absolute;
  left: 0;
  top: 100%;
  z-index: 80;
  min-width: 180px;
  max-width: 420px;
  background: var(--color-white);
  border-radius: 6px;
  box-shadow: 0 2px 30px rgba(0, 0, 0, 0.18);
  padding: 4px 0;
  display: flex;
  flex-direction: column;
  text-align: left;

  &.right {
    left: auto;
    right: 0;
  }

  // пункты приходят слотом из открывшего панель компонента: общий вид у них здесь,
  // класс-хук — единственное, что о них известно
  ::v-deep .spec-popover-item {
    display: block;
    box-sizing: border-box;
    width: 100%;
    border: none;
    background: none;
    font: inherit;
    font-size: 13px;
    text-align: left;
    padding: 8px 14px;
    cursor: pointer;
    color: var(--color-dark-gray);
    white-space: nowrap;

    &:hover {
      background: var(--color-purple);
    }

    &.wrap {
      white-space: normal;
      word-break: break-all;
    }
  }
}
</style>
